export default __webpack_public_path__ + "static/media/ios-s2.8138e153.webp";